import React from "react";
import { Typography } from "antd";

type TitleSubtitleProps = {
  title: string;
  subtitle?: string;
};

const TitleSubtitle: React.FC<TitleSubtitleProps> = ({ title, subtitle }) => {
  return (
    <div style={{ margin: "0px 0px 10px 0px" }}>
      <Typography.Text style={{ fontSize: "20px",
        color: "grey" }}> {title} </Typography.Text>
      <br />
      <Typography.Text strong style={{ fontSize: "24px" }}>
        {subtitle ?? "NA"}
      </Typography.Text>
    </div>
  );
};

export default TitleSubtitle;
